import React from 'react';
import { Button, Input, Modal, Select, Space, Table } from 'antd';
import { formatDate } from 'utils/date';

const columns = [
  {
    title: 'Shop',
    sorter: (a, b) => new Date(a?.create_on || 0) - new Date(b?.create_on || 0),
    defaultSortOrder: 'descend',
    render: (_, record) => (
      <>
        <div>
          <Space>
            {record?.web_site?.title}
            <a href={`https://${record?.web_site?.url}.sipro.store`} target='_blank' rel='noreferrer'>Xem</a>
          </Space>
        </div>
        <div>{formatDate(record?.create_on)}</div>
      </>
    ),
  },
  {
    title: 'Liên hệ',
    render: (_, record) => (
      <>
        <div>
          <Space>
            {record?.owner?.phone}
            {record?.owner?.full_name}
          </Space>
        </div>
      </>
    ),
  },
  {
    title: 'Chỉ số',
    render: (_, record) => (
      <>
        <div>Sản phẩm: {record?.product_count || 0}</div>
        <div>Đơn tháng này: {record?.order_count_month || 0}</div>
      </>
    ),
  },
];

const Desktop = ({ viewModel }) => {
  const {
    filteredData,
    keyword,
    onKeywordChange,
    packageFilter,
    onPackageFilterChange,
    expiryFilter,
    onExpiryFilterChange,
    getPackageName,
    openRenewModal,
    renewTarget,
    packages,
    renewPackageKey,
    setRenewPackageKey,
    renewDuration,
    setRenewDuration,
    renewSubmitting,
    closeRenewModal,
    submitRenew,
  } = viewModel;

  const tableColumns = [
    ...columns,
    {
      title: 'Gói cước',
      render: (_, record) => (
        <>
          <div>{getPackageName(record)}</div>
          <div>Hết hạn: {formatDate(record?.subscription?.expiry_on) || '-'}</div>
        </>
      ),
    },
    {
      title: 'Thao tác',
      render: (_, record) => (
        <Button onClick={() => openRenewModal(record)}>Gia hạn</Button>
      ),
    },
  ];

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <Space wrap>
        <Input
          placeholder='Tìm theo shop, domain, chủ shop, số điện thoại'
          allowClear
          value={keyword}
          onChange={onKeywordChange}
          style={{ width: 420 }}
        />
        <Select value={packageFilter} style={{ width: 200 }} onChange={onPackageFilterChange}>
          <Select.Option value='all'>Tất cả gói</Select.Option>
          {(packages || []).map((item) => (
            <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
          ))}
        </Select>
        <Select value={expiryFilter} style={{ width: 220 }} onChange={onExpiryFilterChange}>
          <Select.Option value='all'>Tất cả hạn dùng</Select.Option>
          <Select.Option value='expiring_7d'>Sắp hết hạn (7 ngày)</Select.Option>
        </Select>
      </Space>

      <Table rowKey={(record) => record.id || record._id || record?.web_site?.url} columns={tableColumns} dataSource={filteredData} />

      <Modal
        title='Gia hạn gói cước'
        open={!!renewTarget}
        onCancel={closeRenewModal}
        onOk={submitRenew}
        okText='Xác nhận gia hạn'
        cancelText='Đóng'
        confirmLoading={renewSubmitting}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>Shop: {renewTarget?.web_site?.title || '-'}</div>
          <div>
            <label>Gói cước</label>
            <Select value={renewPackageKey} style={{ width: '100%' }} onChange={setRenewPackageKey}>
              {(packages || []).map((item) => (
                <Select.Option key={item.key} value={item.key}>{item.name}</Select.Option>
              ))}
            </Select>
          </div>
          <div>
            <label>Số tháng</label>
            <Select value={renewDuration} style={{ width: '100%' }} onChange={setRenewDuration}>
              <Select.Option value={1}>1 tháng</Select.Option>
              <Select.Option value={3}>3 tháng</Select.Option>
              <Select.Option value={6}>6 tháng</Select.Option>
            </Select>
          </div>
        </Space>
      </Modal>
    </div>
  );
};

export default Desktop;